import { TileLayout, TileLayoutItem } from "@progress/kendo-react-layout";
import { IntradayCurvesChart, PromptContractsChart, VolatilityChart } from "../charts";

interface IMarketsAnalyticsProps {
  commodity: any | null;
  refresh?: number;
}

export const MarketsAnalytics = ({ commodity, refresh }: IMarketsAnalyticsProps) => {
  let tileData: any[] = [
    { row: 1, col: 1, colSpan: 12 },
    { row: 2, col: 1, colSpan: 6 },
    { row: 2, col: 7, colSpan: 6 },
  ];

  let tiles: TileLayoutItem[] = [
    {
      style: { background: "transparent", border: "none", height: "auto" },
      item: <IntradayCurvesChart commodity={commodity} refresh={refresh} />,
      reorderable: false,
      resizable: false,
    },
    {
      style: { background: "transparent", border: "none" },
      item: <PromptContractsChart commodity={commodity} refresh={refresh} />,
      reorderable: false,
      resizable: false,
    },
    {
      style: { background: "transparent", border: "none" },
      item: <VolatilityChart commodity={commodity} refresh={refresh} />,
      reorderable: false,
      resizable: false,
    },
  ];

  return <div>{commodity && <TileLayout columns={12} positions={tileData} items={tiles} />}</div>;
};
